const React = require('react');
const {Router, Route} = require('react-router');

import Container from './ui/layout/container.jsx';
import IntlWrapper from './ui/layout/intlWrapper';


const createRouter = (history) =>
  <IntlWrapper>
    <Router history={history}>
      <Route path='/' component={Container}>
      </Route>
    </Router>
  </IntlWrapper>

;

module.exports = createRouter;
